// extracted by mini-css-extract-plugin
export default {"content":"Songs_content__D2JEv"};